import React, { useState } from "react";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import "../styles/Z1.css";

// ⭐ Example 5 rows data – replace with your images, headings & text

import img1 from "../assets/images/item2/subitm1.jpg";
import img2 from "../assets/images/item2/subitm2.jpg";
import img3 from "../assets/images/item2/subitm3.jpg";
import img4 from "../assets/images/item2/subitm4.jpg";
import img5 from "../assets/images/item2/subitm5.jpg";

const rowsData = [
  {
    id: 1,
    title: "Refrigerant Cylinder",
    text: "Safe and durable refrigerant cylinders for efficient air conditioning systems.",
    img: img1,
    gradient: "gradient1",
    stars: 4,
    description: `Refrigerant cylinders store and transport refrigerant gases for AC and refrigeration systems. They are designed to ensure safety and prevent leaks during handling and usage. High-quality cylinders maintain the purity of refrigerant for optimal system performance.
`
  },
  {
    id: 2,
    title: "All Types of AC Tools",
    text: "Complete range of AC tools for installation, maintenance, and repair tasks.",
    img: img2,
    gradient: "gradient2",
    stars: 5,
    description: `We offer all types of AC tools required for professional air conditioning work. These include hand tools, manifold sets, leak detectors, and more. Tools are designed for durability, precision, and ease of use.
`
  },
  {
    id: 3,
    title: "Pressure Gauge",
    text: "Accurate pressure gauges for monitoring HVAC and industrial systems.",
    img: img3,
    gradient: "gradient3",
    stars: 3,
    description: `Pressure gauges measure and monitor system pressure in AC, refrigeration, and industrial equipment. High-precision instruments ensure reliable readings for safe operation. Durable construction withstands tough industrial and mechanical environments.
`
  },
  {
    id: 4,
    title: "Copper Pipes",
    text: "Premium copper pipes for efficient HVAC, plumbing, and refrigeration systems.",
    img: img4,
    gradient: "gradient4",
    stars: 4,
    description: `Copper pipes are essential for air conditioning, refrigeration, and plumbing installations. They offer excellent heat conductivity and corrosion resistance for long-term performance. Easy to install and compatible with a wide range of fittings and systems.
`
  },
  {
    id: 5,
    title: "Gas Cylinder",
    text: "High-quality gas cylinders for safe storage and transport of industrial gases.",
    img: img5,
    gradient: "gradient5",
    stars: 5,
    description: `Gas cylinders store and transport gases like refrigerants, oxygen, and industrial gases safely. Designed to withstand high pressure and prevent leaks during handling. Durable materials ensure long service life and consistent performance.
`
  }
];

function Z2() {
  const [selectedRow, setSelectedRow] = useState(null);

  return (
    <>
      <Navbar />

      <section className="z1-section">
        {rowsData.map((row) => (
          <div
            key={row.id}
            className={`z1-row ${row.gradient}`}
            onClick={() => setSelectedRow(row)}
          >
            <div className="z1-img">
              <img src={row.img} alt={row.title} />
            </div>

            <div className="z1-content">
              <h2>{row.title}</h2>
              <p>{row.text}</p>
              <div className="stars">
                {"★".repeat(row.stars)}
                {"☆".repeat(5 - row.stars)}
              </div>
            </div>
          </div>
        ))}
      </section>

      {/* 🔹 Popup / Modal */}
      {selectedRow && (
        <div className="z1-modal-overlay" onClick={() => setSelectedRow(null)}>
          <div
            className="z1-modal"
            onClick={(e) => e.stopPropagation()} // prevent close on inner click
          >
            <h2>{selectedRow.title}</h2>

            <div className="modal-body">
              <div className="modal-img">
                <img src={selectedRow.img} alt={selectedRow.title} />
              </div>
              <div className="modal-text">
                <p>{selectedRow.description}</p>
              </div>
            </div>

            <button
              className="close-btn"
              onClick={() => setSelectedRow(null)}
            >
              Close
            </button>
          </div>
        </div>
      )}

      <Footer />
    </>
  );
}

export default Z2;